import { useState } from "react";
import axios from "axios";
import { API_BASE, FIRM_IMG_BASE } from "@config/env";
import Button from "@common/Button";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@context/AuthContext";
import { useRole } from "@hooks/useRole";

export default function ProfileHeader({ candidate, readOnly = true }) {
  const navigate = useNavigate();
  const { user }  = useAuth();
  const { isResource } = useRole();
  // isFav: 1 = starred, 2 = not starred (matches old code)
  const userId     = user?.user_id;
  const resourceId = candidate?.resource_id;
  const initFav    = candidate?.isFav;
  const [starred, setStarred] = useState(
    typeof initFav === "number" ? initFav === 1 : !!initFav
  );
  const [favBusy, setFavBusy] = useState(false);

  const toggleFav = async () => {
    if (favBusy || !userId || !resourceId) return;
    setFavBusy(true);
    const fd = new FormData();
    fd.append("user_id",    userId);
    fd.append("resource_id", resourceId);
    await axios.post(API_BASE + "change-favorite", fd).catch(() => null);
    setStarred(s => !s);
    setFavBusy(false);
  };

  return (
    <div className="fc-profile-header">
      {/* Top: identity + company */}
      <div className="fc-profile-top">

        {/* Left: avatar + info */}
        <div className="fc-profile-identity flex-grow-1">
          {/* Avatar with star */}
          <div className="position-relative flex-shrink-0">
            <div className="fc-profile-avatar"
              style={{ background: candidate.color + "18", border: `2px solid ${candidate.color}30`, color: candidate.color, overflow:"hidden", position:"relative" }}>
              {candidate.profile_image_path ? (
                <img src={`https://api.firmconnector.com/${candidate.profile_image_path}`} alt={candidate.initials}
                  style={{ width:"100%", height:"100%", objectFit:"cover", position:"absolute", inset:0 }}
                  onError={e=>e.target.style.display="none"} />
              ) : null}
              {candidate.initials}
            </div>
            {!isResource && (
              <button
                onClick={toggleFav}
                className="position-absolute d-flex align-items-center justify-content-center border-0 rounded-circle p-0"
                style={{ width: 22, height: 22, bottom: -4, right: -4, background: starred ? "var(--fc-amber)" : "var(--fc-bg-white)", border: `2px solid ${starred ? "var(--fc-amber)" : "var(--fc-border)"}`, cursor: "pointer", transition: "all 0.2s" }}
                title={starred ? "Remove favourite" : "Add to favourites"}>
                <i className={`fa-${starred ? "solid" : "regular"} fa-star`} style={{ fontSize: 10, color: starred ? "#fff" : "var(--fc-text-hint)" }} />
              </button>
            )}
          </div>

          {/* Name / role / meta */}
          <div className="overflow-hidden">
            <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
              <h1 className="fc-profile-name">{candidate.name}</h1>
            </div>
            {candidate.role && (
              <p className="fc-profile-role mb-1">{candidate.role}</p>
            )}
            <div className="fc-profile-meta">
              {candidate.location && (
                <span className="fc-profile-meta-item">
                  <i className="fa-solid fa-location-dot fc-profile-meta-icon" />{candidate.location}
                </span>
              )}
              {candidate.exp && (
                <span className="fc-profile-meta-item">
                  <i className="fa-solid fa-clock fc-profile-meta-icon" />{candidate.exp}
                </span>
              )}
              {candidate.email && (
                <span className="fc-profile-meta-item fc-profile-meta-email">
                  <i className="fa-solid fa-envelope fc-profile-meta-icon" style={{ color: "var(--fc-blue)" }} />{candidate.email}
                </span>
              )}
              {candidate.phone && (
                <span className="fc-profile-meta-item fc-profile-meta-email">
                  <i className="fa-solid fa-phone fc-profile-meta-icon" style={{ color: "var(--fc-green)" }} />{candidate.phone}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Right: firm logo only */}
        {(candidate.firmLogo || candidate.company) && (
          <div className="fc-profile-company-box">
            <div style={{ background: "var(--fc-bg-light)", border: "1px solid var(--fc-border)", borderRadius: "var(--fc-radius-md)", padding: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {candidate.firmLogo
                ? <img src={FIRM_IMG_BASE + candidate.firmLogo} alt=""
                    style={{ width: 52, height: 52, objectFit: "contain", borderRadius: 8 }}
                    onError={e => e.target.style.display = "none"} />
                : <div style={{ width: 52, height: 52, borderRadius: 8, background: "#E5E7EB", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <i className="fa-solid fa-building" style={{ fontSize: 20, color: "#9CA3AF" }} />
                  </div>
              }
            </div>
          </div>
        )}
      </div>

    </div>
  );
}
